export default __webpack_public_path__ + "static/media/Inter-Regular.23917250.ttf";